import { raise } from '@sparkdotfi/common-universal'

import { TxOverview } from '../types'
import { getChainConfigEntry } from '@/config/chain'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { TransferFromUserFormNormalizedData } from '@/features/dialogs/common/logic/transfer-from-user/form'
import { SavingsAccountRepository } from '@/features/savings/logic/savings-converters/types'

export interface CreateTxOverviewParams {
  formValues: TransferFromUserFormNormalizedData
  chainId: number
  savingsAccounts: SavingsAccountRepository
  susdc: Token
}
export function createTxOverview({ formValues, savingsAccounts, chainId, susdc }: CreateTxOverviewParams): TxOverview {
  const value = formValues.value
  if (value.eq(0)) {
    return { status: 'no-overview' }
  }

  const chainConfig = getChainConfigEntry(chainId)

  const susdcAccountConfig =
    chainConfig.savings?.accounts?.find((account) => account.savingsToken === TokenSymbol('sUSDC')) ??
    raise('sUSDC account config not found')
  const spusdcAccountConfig =
    chainConfig.savings?.accounts?.find((account) => account.savingsToken === TokenSymbol('spUSDC')) ??
    raise('spUSDC account config not found')

  const pointsMultiplierBefore = susdcAccountConfig.sparkPointsMultiplier ?? 0
  const pointsMultiplierAfter = spusdcAccountConfig.sparkPointsMultiplier ?? 0

  return {
    status: 'success',
    susdc,
    currentApy: savingsAccounts.findOneBySavingsTokenSymbol(TokenSymbol('sUSDC')).converter.apy,
    updatedApy: savingsAccounts.findOneBySavingsTokenSymbol(TokenSymbol('spUSDC')).converter.apy,
    pointsMultiplierBefore,
    pointsMultiplierAfter,
    susdcUpgradedAmount: formValues.value,
  }
}
